import type { ConnectDataAttributes } from '@/libs/api/connect/connect.types.ts'
import { APP_ID, DEFAULT_LOCALE } from '@/ts/constants/constants.ts'
import { language } from '@/i18n/i18n.ts'

export function useConnectDataAttributes(): ConnectDataAttributes {
  const element = document.getElementById(APP_ID)
  const locale = element!.getAttribute('data-locale') ?? language(DEFAULT_LOCALE)
  const clientId = element!.getAttribute('data-client')
  const secret = element!.getAttribute('data-secret')
  const partnerId = element!.getAttribute('data-partner-id')
  const brokerNumber = element!.getAttribute('data-broker-number')
  const prefill = element!.getAttribute('data-prefill')

  return {
    locale,
    clientId,
    secret,
    partnerId,
    brokerNumber,
    prefill
  }
}
